const headlines = [
  "Computer Engineer",
  "This is a Linux style desktop environment",
  "Welcome, Welcome",
  "Embedded Software Experience",
  "Machine Learning",
  "Web Development",
  "git push; git pull; git skip;",
  "Be Better than Yesterday",
  "Inspire Tomorrow",
  "Enjoy the Present",
  "I am something of an Arch user myself"
];

export default headlines;